export { formatString as default } from 'choerodon-ui/dataset';
